import { IBaseMapper } from '@/bundles/App/interfaces';
import { IAdCampaignItem } from '@/bundles/Ad/interfaces';
import AdCampaignItem from '@/bundles/Ad/models/AdCampaignItem';

export default class AdCampaignItemToMapper implements IBaseMapper<IAdCampaignItem> {
  mapToModel (data: IAdCampaignItem) {
    return new AdCampaignItem(data);
  }
}
